import axios from 'axios';
import * as actionTypes from './actionTypes';

export const create_start = () => {
  return {
      type: actionTypes.CREATE_START
  }

}
export const create_Success = () => {
  return {
      type: actionTypes.CREATE_SUCCESS
  }

}
 
export const get_documents = (token) => dispatch =>  {
    
    axios.defaults.headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      };
      axios.get('https://apa-reference-finder-backend-3.herokuapp.com/api/').then(res => {
        
        dispatch ({
               type: actionTypes.FETCH_DOCUMENTS ,
            documents: res.data.reverse()
           })
         }); 
}

export const create_document = (token, form_data) => dispatch =>  {
        dispatch(create_start());
        let url = "https://apa-reference-finder-backend-3.herokuapp.com/api/";
        axios.defaults.xsrfCookieName = "csrftoken";
        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        };
         
        axios.post(url, form_data, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }).then(function(res) {
               
                 dispatch(get_documents(token)); 
                if (res.status === 201) {
                  dispatch(create_Success());
                   if (window.confirm("View your submission")) {
                     
                      window.location.href = `/workArea/${res.data.pk}/`
                    }
    }
                            }) 
            .catch(err => console.log(err)) 
            
}

